export default "__VITE_ASSET__GhRcP_1K__"